import angular, { IPromise } from 'angular';

export class NotificacoesService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];
}
